import { render, staticRenderFns } from "./component-b4c019ae.vue?vue&type=template&id=65ed0721&scoped=true&"
import script from "./component-b4c019ae.vue?vue&type=script&lang=js&"
export * from "./component-b4c019ae.vue?vue&type=script&lang=js&"
import style0 from "./component-b4c019ae.vue?vue&type=style&index=0&id=65ed0721&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ed0721",
  null
  
)

export default component.exports